/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */
import $ from 'jquery';
import './home-featured.js';

document.addEventListener('DOMContentLoaded', function () {

    const $homePage = $('.home');

    
    if ($homePage.length != 0) {
        $homePage.find('.call-to-actions .cta.special-overtitle').each(function() {
            const $cta = $(this);
            console.log($cta);
            const $ctaImage = $cta.find('.cta__image');
            $cta.find('.over-title').appendTo($ctaImage);
        });
    }





});